<template>
  <nav class="navbar-expand-lg w-100 background-color--branding p-0">
    <div class="w-100">
      <div class="navbar-header text-right">
        <button
          type="button"
          class="navbar-toggler text-color--midtone"
          aria-expanded="false"
          @click="show = !show"
        >
          <i class="fa fa-bars" />
        </button>
      </div>
      <div
        class="collapse navbar-collapse flex justify-content-between"
        :class="[show ? 'show' : '']"
      >
        <ul class="navbar-nav flex-grow-1 align-items-lg-center gap-lg-1">
          <slot name="main-links" />
        </ul>
        <slot name="extra-links" />
      </div>
    </div>
    <slot />
  </nav>
</template>

<script>
export default {
  name: 'Navbar',
  data() {
    return {
      show: false,
    };
  },
  mounted() {
    const vm = this;
    window.addEventListener('resize', () => {
      vm.show = false;
    });
  },
  unmounted() {
    window.removeEventListener('resize');
  },
};
</script>
